import theme from './theme.vue'
theme.install = function (Vue) {
  Vue.component(theme.name, theme);
};
export default theme



// WEBPACK FOOTER //
// ./src/ni-ui/theme/index.js